/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import { createPopper } from '@popperjs/core';

import DocumentDownloadTypes from '../../enums/DocumentDownloadTypes';

import FileLinkView from '../FileLinkView';

import './TooltipView.css';
import tmplTooltipView from './TooltipView.hbs';

const TooltipView = View.extend({
  template: tmplTooltipView,

  className: 'tooltip-view d-inline',

  ui: {
    tooltip: '.tooltip-div',
    button: '.tooltip-button',
    tooltipText: '.tooltip-text',
    document: '.tooltip-document',
    tooltipContainer: '.tooltip-container'
  },

  regions: {
    document: '@ui.document'
  },

  events: {
    'mouseenter @ui.tooltipContainer': 'showTooltip',
    'focus @ui.tooltipContainer': 'showTooltip',
    'mouseleave @ui.tooltipContainer': 'hideTooltip',
    'blur @ui.tooltipContainer': 'hideTooltip'
  },

  templateContext() {
    return {
      tooltipText: this.model.get('tooltipText').replace(/\n/g, '<br />')
    };
  },

  onRender() {
    if (this.model.get('tooltipDocument')) {
      const document = this.model.get('tooltipDocument');
      this.showChildView(
        'document',
        new FileLinkView({
          model: new Backbone.Model({
            text: document.text ? document.text : document.fileName,
            uuid: document.uuid,
            fileName: document.fileName,
            downloadType: DocumentDownloadTypes.TEMPLATE
          })
        })
      );
    }

    const button = this.ui.button.get(0);
    const tooltip = this.ui.tooltip.get(0);

    this.popperInstance = createPopper(button, tooltip, {
      placement: this.model.get('placement')
    });
  },

  showTooltip() {
    this.ui.tooltip.attr('data-show', '');
    this.popperInstance.update();
  },

  hideTooltip() {
    this.ui.tooltip.removeAttr('data-show');
  }
});

export default TooltipView;